import { ConfirmDialog, useToast } from "@nabble/ui";
import { removePasskey, type Passkey } from "../../../../api/secondFactors";
import { factorErrorMessage } from "./factorErrorMessage";

/** Confirms removing `target`; closed while there is no target. */
export function RemovePasskeyDialog({
  target,
  onClose,
  onRemoved,
}: {
  target: Passkey | null;
  onClose: () => void;
  onRemoved: () => void;
}): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={target !== null}
      tone="danger"
      icon="key"
      title="Remove passkey"
      description={target ? `"${target.label}" will no longer work for signing in.` : undefined}
      confirmLabel="Remove"
      onClose={onClose}
      onConfirm={async () => {
        if (!target) return;
        try {
          await removePasskey(target.id);
          show({ title: "Passkey removed", tone: "success" });
          onRemoved();
        } catch (err) {
          show({ title: "We couldn't remove it", text: factorErrorMessage(err), tone: "danger" });
        }
      }}
    />
  );
}
